import { render, staticRenderFns } from "./EditTermsOfUsePerProduct.vue?vue&type=template&id=ec3d9592&scoped=true&"
import script from "./EditTermsOfUsePerProduct.vue?vue&type=script&lang=js&"
export * from "./EditTermsOfUsePerProduct.vue?vue&type=script&lang=js&"
import style0 from "./EditTermsOfUsePerProduct.vue?vue&type=style&index=0&id=ec3d9592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3d9592",
  null
  
)

export default component.exports